module.exports = __webpack_public_path__ + "pw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/pw.svg
// module id = 772
// module chunks = 0